(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-page"]) return;
  try {
    
  class MateAboutCertifications extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }

    select(id, focus = false) {
      this.querySelectorAll('[data-certification-tab]').forEach((tab) => {
        const active = tab.dataset.certificationTab === id;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });
      this.querySelectorAll('[data-certification-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.certificationPanel !== id;
      });
    }

    handleClick = (event) => {
      const tab = event.target.closest('[data-certification-tab]');
      if (!tab || tab.closest('mate-about-certifications') !== this) return;
      this.select(tab.dataset.certificationTab);
    };

    handleKeydown = (event) => {
      const tab = event.target.closest('[data-certification-tab]');
      if (!tab || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      const tabs = [...this.querySelectorAll('[data-certification-tab]')];
      let index = tabs.indexOf(tab);
      if (event.key === 'ArrowDown') index = (index + 1) % tabs.length;
      if (event.key === 'ArrowUp') index = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') index = 0;
      if (event.key === 'End') index = tabs.length - 1;
      event.preventDefault();
      this.select(tabs[index].dataset.certificationTab, true);
    };

    handleBlockSelect = (event) => {
      const tab = this.querySelector(`[data-certification-tab="${event.detail?.blockId}"]`);
      if (tab) this.select(tab.dataset.certificationTab);
    };
  }

  if (!customElements.get('mate-about-certifications')) {
    customElements.define('mate-about-certifications', MateAboutCertifications);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-recommendations"]) return;
  try {
    
  if (!customElements.get('mate-cart-recommendations')) {
    customElements.define('mate-cart-recommendations', class extends HTMLElement {
      connectedCallback() {
        document.addEventListener('mate:cart-updated', this.handleCartUpdated);
        document.addEventListener('mate:cart-state-updated', this.refresh);
        this.loadRecommendations({ immediate: true });
      }

      disconnectedCallback() {
        this.loadId = (this.loadId || 0) + 1;
        this.observer?.disconnect();
        document.removeEventListener('mate:cart-updated', this.handleCartUpdated);
        document.removeEventListener('mate:cart-state-updated', this.refresh);
      }

      handleCartUpdated = (event) => {
        if (event.detail?.source === 'add-to-cart') return;
        this.refresh();
      };

      refresh = async () => {
        this.loadId = (this.loadId || 0) + 1;
        const loadId = this.loadId;
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Cart recommendations refresh failed');
          const html = await response.text();
          if (loadId !== this.loadId || !this.isConnected) return;
          const next = new DOMParser().parseFromString(html, 'text/html').querySelector('mate-cart-recommendations');
          if (next) this.replaceWith(next);
          else {
            this.replaceChildren();
            this.hidden = true;
          }
        } catch (error) {
          if (loadId !== this.loadId || !this.isConnected) return;
          this.dispatchEvent(new CustomEvent('mate:cart-recommendations-error', { bubbles: true, detail: { error } }));
        }
      };

      loadRecommendations({ immediate = false } = {}) {
        if (this.dataset.loaded === 'true' || !this.dataset.recommendationsUrl) return;
        this.observer?.disconnect();
        this.observer = null;
        this.dataset.loaded = 'true';
        this.loadId = (this.loadId || 0) + 1;
        const loadId = this.loadId;

        const load = async () => {
          try {
            const response = await fetch(this.dataset.recommendationsUrl, {
              credentials: 'same-origin',
              headers: { 'X-Requested-With': 'XMLHttpRequest' },
            });
            if (!response.ok) throw new Error(`Recommendation request failed with ${response.status}`);
            const html = await response.text();
            if (loadId !== this.loadId || !this.isConnected) return;
            const documentFragment = new DOMParser().parseFromString(html, 'text/html');
            const next = documentFragment.querySelector('mate-cart-recommendations');
            if (!next?.innerHTML.trim()) {
              this.replaceChildren();
              this.hidden = true;
              return;
            }
            next.hidden = false;
            this.replaceWith(next);
            document.dispatchEvent(new CustomEvent('mate:content-loaded', {
              detail: { source: 'cart-recommendations' },
            }));
          } catch (error) {
            if (loadId !== this.loadId || !this.isConnected) return;
            this.dispatchEvent(new CustomEvent('mate:cart-recommendations-error', {
              bubbles: true,
              detail: { error },
            }));
          }
        };

        if (!immediate && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.observer.disconnect();
            load();
          }, { rootMargin: '300px 0px' });
          this.observer.observe(this);
        } else {
          load();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-register"] && !Shopify.designMode) return;
  try {
    
  class MateCustomerRegister extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.password = this.querySelector('[data-register-password]');
      this.confirmation = this.querySelector('[data-register-password-confirmation]');
      if (!this.form || !this.password || !this.confirmation) return;

      this.form.addEventListener('submit', this.validateConfirmation);
      this.confirmation.addEventListener('input', this.validateConfirmation);
      this.password.addEventListener('input', this.validateConfirmation);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.validateConfirmation);
      this.confirmation?.removeEventListener('input', this.validateConfirmation);
      this.password?.removeEventListener('input', this.validateConfirmation);
    }

    validateConfirmation = (event) => {
      const matches = this.password.value === this.confirmation.value;
      this.confirmation.setCustomValidity(matches ? '' : this.confirmation.dataset.mismatchMessage);
      if (event.type === 'submit' && !matches) this.confirmation.reportValidity();
    };
  }

  if (!customElements.get('mate-customer-register')) {
    customElements.define('mate-customer-register', MateCustomerRegister);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fabric-library-catalog"] && !Shopify.designMode) return;
  try {
    
  class MateFabricLibraryTabs extends HTMLElement {
    connectedCallback() {
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
      if (this.mobileQuery.addEventListener) {
        this.mobileQuery.addEventListener('change', this.handleBreakpointChange);
      } else {
        this.mobileQuery.addListener(this.handleBreakpointChange);
      }
      this.handleBreakpointChange();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      if (this.mobileQuery?.removeEventListener) {
        this.mobileQuery.removeEventListener('change', this.handleBreakpointChange);
      } else {
        this.mobileQuery?.removeListener(this.handleBreakpointChange);
      }
    }

    getVisibleTabs() {
      return [...this.querySelectorAll('[data-fabric-library-tab]')].filter(
        (tab) => !this.mobileQuery.matches || tab.dataset.fabricLibraryMobileVisible !== 'false',
      );
    }

    select(id, focus = false) {
      this.querySelectorAll('[data-fabric-library-tab]').forEach((tab) => {
        const active = tab.dataset.fabricLibraryTab === id;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        tab.lastElementChild.textContent = active ? '−' : '+';
        if (active && focus) tab.focus();
      });
      this.querySelectorAll('[data-fabric-library-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.fabricLibraryPanel !== id;
        if (!panel.hidden) {
          customElements.whenDefined('mate-carousel').then(() => {
            if (panel.isConnected && !panel.hidden) panel.querySelector('mate-carousel')?.refresh();
          });
        }
      });
    }

    handleClick = (event) => {
      const tab = event.target.closest('[data-fabric-library-tab]');
      if (!tab || tab.closest('mate-fabric-library-tabs') !== this) return;
      const collapse = tab.getAttribute('aria-selected') === 'true';
      this.select(collapse ? null : tab.dataset.fabricLibraryTab);
      if (collapse) tab.tabIndex = 0;
    };

    handleKeydown = (event) => {
      const tab = event.target.closest('[data-fabric-library-tab]');
      if (!tab || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      const tabs = this.getVisibleTabs();
      let index = tabs.indexOf(tab);
      if (event.key === 'ArrowDown') index = (index + 1) % tabs.length;
      if (event.key === 'ArrowUp') index = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') index = 0;
      if (event.key === 'End') index = tabs.length - 1;
      event.preventDefault();
      this.select(tabs[index].dataset.fabricLibraryTab, true);
    };

    handleBreakpointChange = () => {
      const visibleTabs = this.getVisibleTabs();
      const selectedTab = this.querySelector('[data-fabric-library-tab][aria-selected="true"]');
      if (selectedTab && visibleTabs.length > 0 && !visibleTabs.includes(selectedTab)) {
        this.select(visibleTabs[0].dataset.fabricLibraryTab);
        return;
      }
      if (!selectedTab) {
        this.querySelectorAll('[data-fabric-library-tab]').forEach((tab) => {
          tab.tabIndex = -1;
        });
        if (visibleTabs[0]) visibleTabs[0].tabIndex = 0;
      }
    };

    handleBlockSelect = (event) => {
      const tab = this.querySelector(`[data-fabric-library-tab="${event.detail?.blockId}"]`);
      if (tab) this.select(tab.dataset.fabricLibraryTab);
    };
  }

  if (!customElements.get('mate-fabric-library-tabs')) {
    customElements.define('mate-fabric-library-tabs', MateFabricLibraryTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fabric-library"] && !Shopify.designMode) return;
  try {
    
  class MateFabricLibraryTabs extends HTMLElement {
    connectedCallback() {
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
      if (this.mobileQuery.addEventListener) {
        this.mobileQuery.addEventListener('change', this.handleBreakpointChange);
      } else {
        this.mobileQuery.addListener(this.handleBreakpointChange);
      }
      this.handleBreakpointChange();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      if (this.mobileQuery?.removeEventListener) {
        this.mobileQuery.removeEventListener('change', this.handleBreakpointChange);
      } else {
        this.mobileQuery?.removeListener(this.handleBreakpointChange);
      }
    }

    getVisibleTabs() {
      return [...this.querySelectorAll('[data-fabric-library-tab]')].filter(
        (tab) => !this.mobileQuery.matches || tab.dataset.fabricLibraryMobileVisible !== 'false',
      );
    }

    select(id, focus = false) {
      this.querySelectorAll('[data-fabric-library-tab]').forEach((tab) => {
        const active = tab.dataset.fabricLibraryTab === id;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        tab.lastElementChild.textContent = active ? '−' : '+';
        if (active && focus) tab.focus();
      });
      this.querySelectorAll('[data-fabric-library-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.fabricLibraryPanel !== id;
      });
    }

    handleClick = (event) => {
      const tab = event.target.closest('[data-fabric-library-tab]');
      if (!tab || tab.closest('mate-fabric-library-tabs') !== this) return;
      const collapse = tab.getAttribute('aria-selected') === 'true';
      this.select(collapse ? null : tab.dataset.fabricLibraryTab);
      if (collapse) tab.tabIndex = 0;
    };

    handleKeydown = (event) => {
      const tab = event.target.closest('[data-fabric-library-tab]');
      if (!tab || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      const tabs = this.getVisibleTabs();
      let index = tabs.indexOf(tab);
      if (event.key === 'ArrowDown') index = (index + 1) % tabs.length;
      if (event.key === 'ArrowUp') index = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') index = 0;
      if (event.key === 'End') index = tabs.length - 1;
      event.preventDefault();
      this.select(tabs[index].dataset.fabricLibraryTab, true);
    };

    handleBreakpointChange = () => {
      const visibleTabs = this.getVisibleTabs();
      const selectedTab = this.querySelector('[data-fabric-library-tab][aria-selected="true"]');
      if (selectedTab && visibleTabs.length > 0 && !visibleTabs.includes(selectedTab)) {
        this.select(visibleTabs[0].dataset.fabricLibraryTab);
        return;
      }
      if (!selectedTab) {
        this.querySelectorAll('[data-fabric-library-tab]').forEach((tab) => {
          tab.tabIndex = -1;
        });
        if (visibleTabs[0]) visibleTabs[0].tabIndex = 0;
      }
    };

    handleBlockSelect = (event) => {
      const tab = this.querySelector(`[data-fabric-library-tab="${event.detail?.blockId}"]`);
      if (tab) this.select(tab.dataset.fabricLibraryTab);
    };
  }

  if (!customElements.get('mate-fabric-library-tabs')) {
    customElements.define('mate-fabric-library-tabs', MateFabricLibraryTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class MateFaq extends HTMLElement {
    states = new WeakMap();

    connectedCallback() {
      this.addEventListener('click', this.handleClick);
      document.addEventListener('click', this.handleAnchorClick);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('click', this.handleAnchorClick);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.querySelectorAll('.mate-faq__item').forEach((item) => {
        const state = this.states.get(item);
        state?.animation?.cancel();
        state?.contentAnimation?.cancel();
        if (state?.animation) item.open = state.targetOpen;
        item.style.removeProperty('height');
        item.style.removeProperty('overflow');
        delete item.dataset.faqState;
      });
    }

    get singleOpen() {
      return this.hasAttribute('data-single-open');
    }

    handleAnchorClick = (event) => {
      const anchor = event.target.closest?.('a[href^="#"]');
      const isModifiedClick = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
      if (
        !anchor ||
        event.defaultPrevented ||
        event.button !== 0 ||
        isModifiedClick ||
        (anchor.target && anchor.target !== '_self')
      ) {
        return;
      }

      const target = document.getElementById(decodeURIComponent(anchor.hash.slice(1)));
      if (!target || !this.contains(target)) return;

      event.preventDefault();
      const headerBottom =
        Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--mate-header-bottom')) || 95;
      const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerBottom - 24);
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

      if (window.location.hash !== anchor.hash) history.pushState(null, '', anchor.hash);
      window.scrollTo({ top, behavior });
      target.focus({ preventScroll: true });
    };

    handleClick = (event) => {
      const summary = event.target.closest('.mate-faq__item > summary');
      if (!summary || summary.closest('mate-faq') !== this) return;

      const item = summary.parentElement;
      const answer = item.querySelector(':scope > .mate-faq__answer');
      const state = this.states.get(item);
      const targetOpen = state?.animation ? !state.targetOpen : !item.open;

      if (targetOpen && this.singleOpen) this.closeOtherItems(item);

      const canAnimate =
        answer &&
        typeof item.animate === 'function' &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!canAnimate) {
        if (state?.animation) this.settleItem(item, state.targetOpen);
        return;
      }

      event.preventDefault();
      this.animateItem(item, summary, answer, targetOpen);
    };

    handleBlockSelect = (event) => {
      const item = event.target.closest?.('.mate-faq__item');
      if (!item || item.closest('mate-faq') !== this) return;

      if (this.singleOpen) this.closeOtherItems(item);

      const state = this.states.get(item);
      state?.animation?.cancel();
      state?.contentAnimation?.cancel();
      item.style.removeProperty('height');
      item.style.removeProperty('overflow');
      delete item.dataset.faqState;
      item.open = true;
      this.states.set(item, { animation: null, contentAnimation: null, targetOpen: true });
    };

    closeOtherItems(activeItem) {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.querySelectorAll('.mate-faq__item').forEach((item) => {
        if (item === activeItem) return;

        const state = this.states.get(item);
        const isOpen = state?.animation ? state.targetOpen : item.open;
        if (!isOpen) return;

        const summary = item.querySelector(':scope > summary');
        const answer = item.querySelector(':scope > .mate-faq__answer');
        if (summary && answer && typeof item.animate === 'function' && !reducedMotion) {
          this.animateItem(item, summary, answer, false);
          return;
        }

        this.settleItem(item, false);
      });
    }

    settleItem(item, open) {
      const state = this.states.get(item);
      state?.animation?.cancel();
      state?.contentAnimation?.cancel();
      item.style.removeProperty('height');
      item.style.removeProperty('overflow');
      delete item.dataset.faqState;
      item.open = open;
      this.states.set(item, { animation: null, contentAnimation: null, targetOpen: open });
    }

    animateItem(item, summary, answer, open) {
      const previous = this.states.get(item);
      const currentHeight = item.getBoundingClientRect().height;
      const currentAnswerStyles = previous ? getComputedStyle(answer) : null;
      const startOpacity = currentAnswerStyles?.opacity ?? (open ? '0' : '1');
      const startTransform = currentAnswerStyles?.transform ?? (open ? 'translateY(-6px)' : 'translateY(0)');

      item.style.height = `${currentHeight}px`;
      item.style.overflow = 'hidden';
      previous?.animation?.cancel();
      previous?.contentAnimation?.cancel();

      if (open) item.open = true;

      const borderHeight = item.offsetHeight - item.clientHeight;
      let targetHeight = summary.getBoundingClientRect().height + borderHeight;
      if (open) {
        item.style.height = 'auto';
        targetHeight = item.getBoundingClientRect().height;
        item.style.height = `${currentHeight}px`;
      }

      item.dataset.faqState = open ? 'opening' : 'closing';
      const animation = item.animate(
        { height: [`${currentHeight}px`, `${targetHeight}px`] },
        {
          duration: open ? 280 : 220,
          easing: 'cubic-bezier(.22, 1, .36, 1)',
        },
      );
      const contentAnimation = answer.animate(
        [
          { opacity: startOpacity, transform: startTransform },
          { opacity: open ? '1' : '0', transform: open ? 'translateY(0)' : 'translateY(-6px)' },
        ],
        {
          duration: open ? 240 : 160,
          easing: 'cubic-bezier(.22, 1, .36, 1)',
          fill: 'both',
        },
      );
      const state = { animation, contentAnimation, targetOpen: open };
      this.states.set(item, state);

      animation.addEventListener('finish', () => {
        if (this.states.get(item) !== state) return;
        item.open = open;
        item.style.removeProperty('height');
        item.style.removeProperty('overflow');
        delete item.dataset.faqState;
        contentAnimation.cancel();
        this.states.set(item, { animation: null, contentAnimation: null, targetOpen: open });
      });
    }
  }

  if (!customElements.get('mate-faq')) {
    customElements.define('mate-faq', MateFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-fabric-carousel"] && !Shopify.designMode) return;
  try {
    
  class MateFabric extends HTMLElement {
    scrollFrame = 0;

    connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      window.cancelAnimationFrame(this.scrollFrame);
    }

    handleClick = (event) => {
      const button = event.target.closest('[data-fabric-tab]');
      if (!button) return;
      const selectionChanged = button.getAttribute('aria-pressed') !== 'true';

      this.querySelectorAll('[data-fabric-tab]').forEach((tab) => {
        tab.setAttribute('aria-pressed', String(tab === button));
      });
      this.querySelectorAll('[data-fabric-copy]').forEach((copy) => {
        copy.hidden = copy.dataset.fabricCopy !== button.dataset.fabricTab;
      });
      this.querySelectorAll('[data-fabric-image]').forEach((image) => {
        image.hidden = image.dataset.fabricImage !== button.dataset.fabricTab;
      });

      if (
        !selectionChanged ||
        event.detail === 0 ||
        !window.matchMedia('(max-width: 749px)').matches
      ) return;

      window.cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = window.requestAnimationFrame(() => {
        this.scrollFrame = 0;
        if (!this.isConnected) return;
        const stage = this.querySelector('.mate-fabric__stage');
        if (!stage) return;
        const headerBottom = Math.max(
          0,
          document.querySelector('.mate-header__bar')?.getBoundingClientRect().bottom || 0,
        );
        const top = window.scrollY + stage.getBoundingClientRect().top - headerBottom;
        window.scrollTo({
          top: Math.max(0, top),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      });
    };
  }

  if (!customElements.get('mate-fabric')) {
    customElements.define('mate-fabric', MateFabric);
  }

  } catch(e) { console.error(e); }
})();
})();
